import { useCallback } from 'react';
import { themeDarkOption } from '../../utils/get-dark';
import { callNativeAsync, registerNativeAsync } from '../../utils/ds-bridge';
import { AppIpc } from '@flowus/shared';

export const useAIChatIpc = () => {
  return useCallback(() => {
    const updateGloBalConfig = (data: any) => {
      if (data?.theme === 'dark') {
        themeDarkOption.add();
      } else {
        themeDarkOption.remove();
      }
    };

    const refreshConfig = () => {
      callNativeAsync({ event: AppIpc.GET_GLOBAL_CONFIG }, (res) => {
        updateGloBalConfig(res.data);
      });
    };

    registerNativeAsync(AppIpc.UPDATE_GLOBAL_CONFIG, () => {
      refreshConfig();
    });
  }, []);
};
